import { useState } from 'react'

import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'

import { CreateProjectdossierDialog } from '../../projectdossiers/components/dialogs/CreateProjectdossierDialog'
import { useParams } from '../../router/hooks/useParams'
import { Page } from '../../theme/components/Page'
import { PageSection } from '../../theme/components/PageSection'
import { useValuelists } from '../../valuelists/hooks/useValuelists'
import { ProjectmeldingGegevens } from '../components/ProjectmeldingGegevens'
import { Afwijzen } from '../components/dialogs/Afwijzen'
import { useProjectmelding } from '../hooks/useProjectmelding'

export const Projectmelding = () => {
  const { id } = useParams()
  const { data: valuelists } = useValuelists()
  const { data: projectmelding } = useProjectmelding({ id })
  const [isOpenAfwijzen, setIsOpenAfwijzen] = useState(false)
  const [open, setOpen] = useState(false)

  return (
    <Page
      title={[
        projectmelding ? `${projectmelding.projectName}` : 'Vooraanmelding',
        'Ketensamenwerking',
      ]}
      breadcrumbs={[
        { label: 'Ketensamenwerking', href: '/home', tooltip: 'CAPO home' },
        {
          label: 'Vooraanmeldingen',
          href: '/vooraanmeldingen',
          tooltip: 'Vooraanmeldingen overzicht',
        },
        {
          label: projectmelding ? projectmelding.projectName : 'Vooraanmelding',
        },
      ]}
    >
      <PageSection
        id="projectmelding"
        heading={
          !projectmelding
            ? 'Vooraanmelding niet gevonden'
            : `Vooraanmelding ${projectmelding.projectName}`
        }
      />

      {projectmelding && (
        <>
          <Card sx={{ mt: 3, mb: 2, w: '100%', pb: 4 }}>
            <CardContent>
              <ProjectmeldingGegevens
                projectmelding={projectmelding}
                onClickCreate={() => setOpen(true)}
                onClickAfwijzen={() => setIsOpenAfwijzen(true)}
              />
            </CardContent>
          </Card>

          {open && (
            <CreateProjectdossierDialog
              projectmelding={projectmelding}
              onClose={() => setOpen(false)}
              gebieden={valuelists.gebieden}
            />
          )}

          {isOpenAfwijzen && (
            <Afwijzen
              id={projectmelding.id}
              handleClose={() => setIsOpenAfwijzen(false)}
            />
          )}
        </>
      )}
    </Page>
  )
}
